import Crud from '../components/Justification/Crud'
import Add from '../components/Justification/Add'
import Edit from '../components/Justification/Edit'

let routes = {
    path: '/justifications',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/justifications/add',
            name: 'Nova Justificativa',
            component: Add
        },
        {
            path: '/justifications/edit/:id?',
            name: 'Editar Justificativa',
            component: Edit
        },
        {
            path: '/justifications',
            name: 'Justificativas',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/justification.js